/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  errorText: {
    color: theme.palette.error.main,
    fontSize: theme.spacing(1.5),
    fontWeight: "normal",
  },
  formStyle: {
    padding: theme.spacing(1.5, 1),
    "& .MuiSelect-selectMenu": {
      minHeight: theme.spacing(1.725),
    },
    display: "flex",
    alignItems: "center",
    width: "inherit",
  },
  formStyleTransferList: {
    paddingTop: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    width: "inherit",
  },
  organizationDropdownBox: {
    maxWidth: theme.spacing(32),
  },
  organizationDropdown: {
    width: theme.spacing(32),
  }
}));
